import React, { FC, useRef } from 'react'
import { TooltipTrigger } from 'antd/lib/tooltip'
import { getTitle, UIPlacement, UITypes } from 'LibNeo'
import { createPortal } from 'react-dom'
import { PopoverOverlayStyled, PopoverStyled } from './styled'

export interface PopoverProps {
	trigger?: TooltipTrigger
	content: string | JSX.Element
	title?: string | JSX.Element
	titleCode?: string
	className?: string
	placement?: UIPlacement
	type?: UITypes
	visible?: boolean // visible и onVisibleChange необходимы для возможности программного скрытия
	onVisibleChange?: (isVisible: boolean) => void
	mouseEnterDelay?: number
	overlay?: React.ElementType
}

export const PopoverComponent: FC<PopoverProps> = ({
	children,
	content,
	trigger = 'click',
	title,
	titleCode,
	className,
	placement,
	type,
	visible,
	onVisibleChange,
	mouseEnterDelay,
	overlay,
}) => {
	const PopoverOverlay = overlay ?? PopoverOverlayStyled
	const popsForProgramHiding = onVisibleChange ? { visible, onVisibleChange } : {}
	const el = useRef()

	return (
		<PopoverStyled
			{...popsForProgramHiding}
			placement={placement}
			content={content}
			trigger={trigger}
			title={getTitle(title, titleCode)}
			mouseEnterDelay={mouseEnterDelay}
			getTooltipContainer={() => el.current}
			className={className}
		>
			{children}
			{createPortal(<PopoverOverlay ref={el} type={type} />, document.body)}
		</PopoverStyled>
	)
}
